import React, { useState } from 'react';
import { BiArrowFromLeft, BiArrowFromRight } from 'react-icons/bi';
import * as indexConteneurInfo from '../../../../ressources/glossaires/glossaire_conteneur_info';
import * as type_btn from '../../../../ressources/glossaires/glossaire_type_de_bouton';
import ConteneurInformation from '../../../ConteneurInformation/ConteneurInformation';
import Bouton from '../../../UI/Bouton/Bouton';
import S from './Graphe.module.scss';
import FormulaireGraphe from './ProfilGraphe/FormulaireGraphe/FormulaireGraphe';
import ProfilGraphe from './ProfilGraphe/ProfilGraphe';
import TableauGraphe from './TableauGraphe/TableauGraphe';

const Graphe = ({ siLaListeAUneValeur }) => {
  const [parametresSelectione, setParametresSelectione] = useState({});
  const [montrerInfo, setMontrerInfo] = useState(false);
  const [indexConteneurInfoState, setIndexConteneurInfo] = useState(null);
  const [montrerInfoFull, setMontrerInfoFull] = useState(false);

  const ligneSelectione = (info) => {
    setParametresSelectione(info);
    setIndexConteneurInfo(indexConteneurInfo.profil);
    setMontrerInfo(true);
  };

  const commutateurInfoCreer = () => {
    if (montrerInfo) {
      setMontrerInfo(false);
      setMontrerInfoFull(false);
    } else {
      setMontrerInfo(true);
    }
  };

  const commutateurInfoFull = () => {
    setMontrerInfoFull(!montrerInfoFull);
  };

  const commutateurAnnuler = () => {
    setMontrerInfo(false);
    setIndexConteneurInfo(null);
  };

  const creerGraphe = () => {
    setMontrerInfo(true);
    setIndexConteneurInfo(indexConteneurInfo.ajouterForm);
  };

  let styleConteneurCentralGauche = [S.ConteneurCentralGauche];
  let styleConteneurCentralDroite = [S.ConteneurCentralDroite];
  let commutateurClasses = [S.CommutateurInfo];

  if (montrerInfo && montrerInfoFull) {
    styleConteneurCentralDroite.push(S.ConteneurCentralDroiteFull);
    styleConteneurCentralGauche.push(S.ConteneurCentraGaucheVoid);
  } else if (montrerInfo && !montrerInfoFull) {
    styleConteneurCentralDroite.push(S.ConteneurCentralDroiteOuvert);
  } else {
    styleConteneurCentralDroite.push(S.ConteneurCentralDroiteFermer);
    styleConteneurCentralGauche.push(S.ConteneurCentraGaucheFermer);
  }

  return (
    <>
      <div className={[S.ConteneurGraphe].join(' ')}>
        <div className={styleConteneurCentralGauche.join(' ')}>
          <TableauGraphe
            siLaListeAUneValeur={siLaListeAUneValeur}
            projetSelectione={ligneSelectione}
            creer={creerGraphe}
          />
        </div>
        <div className={styleConteneurCentralDroite.join(' ')}>
          <Bouton
            ajoutClass={[commutateurClasses, S.expandTO].join(' ')}
            cliquer={commutateurInfoCreer}
            rond={true}
            type={type_btn.danger}
          >
            <BiArrowFromLeft size={15} />
          </Bouton>
          <Bouton
            ajoutClass={S.expand}
            cliquer={commutateurInfoFull}
            rond={true}
            type={type_btn.danger}
          >
            <BiArrowFromRight size={15} />
          </Bouton>
          <ConteneurInformation
            selectionInfo={indexConteneurInfoState}
            ajouterForm={<FormulaireGraphe annuler={commutateurAnnuler} />}
            profil={<ProfilGraphe infoGraphe={parametresSelectione} />}
          />
        </div>
      </div>
    </>
  );
};

export default Graphe;
